module.exports = __webpack_public_path__ + "img/Mob_Slider3.57fdcff8.svg";